import React, { Component } from 'react';
import style from './application.layout.less';
import LeftBar from '../leftbar/leftbar.jsx';
import Topbar from '../topbar/topbar.jsx';
import RightBar from '../rightbar/rightbar.jsx';
import Contentbox from '../contentbox/contentbox.jsx';

export default class ApplicationLayout extends Component {
    render() {
        const { language, headerLink, navigationPageList, pageList,
            lastPageIndex, currentPageIndex, fields, errorText } = this.props;
        const props = { language, headerLink, navigationPageList, pageList,
            lastPageIndex, currentPageIndex, fields, errorText };
        return (
            <div className={style.applicationLayout}>
                <div className={style.applicationLayout__fluidWrapper}>
                    <div className={style.applicationLayout__innerContainer}>
                        <LeftBar {...props}/>
                        <RightBar {...props}/>
                        <Topbar {...props}/>
                        <Contentbox>
                            { this.props.children }
                        </Contentbox>
                    </div>
                </div>
            </div>
        );
    }
}
